import React from "react";
import { VisuallyHidden } from "react-aria";

import type { Context } from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";

import styles from "./SocialIcons.module.scss";

export const SocialContext = React.createContext<
    React.ComponentProps<typeof Context>["value"]["socials"]
>({ sites: [] });

export const SocialIcons = ({ className }: { className?: string }) => (
    <ul className={concatClassNames([className, styles.root])}>
        {React.useContext(SocialContext)?.sites.map((site) => (
            <li key={site.name}>
                <Clickable href={site.url} target="_blank" icon={null}>
                    <VisuallyHidden>{site.name}</VisuallyHidden>
                    <ImageChooserBlock
                        value={site.icon.block}
                        attrs={{ "aria-hidden": true }}
                    />
                </Clickable>
            </li>
        ))}
    </ul>
);
